import { ConfigProvider, notification, Spin, Table } from "antd";
import React, { useEffect } from "react";
import { EditFilled, EditOutlined, ReloadOutlined } from "@ant-design/icons";
import useApiInterceptor from "../../../hooks/useInterceptor";
import { useSelector } from "react-redux";
import { decryptAES, encryptAES } from "../../../redux/middleware/encryptPayloadUtils";
import PermissionModal from "./PermissionModal";
import { toast } from "react-toastify";
import EditModal from "./EditModal";
import { openNotification } from "../../Auth/utils/Notification";

const UserTable = ({ userData , handleGetUserData}) => {
  const apiInterceptor = useApiInterceptor();
  const [api, contextHolder] = notification.useNotification();
  const currentRole = useSelector((state) => state.user.userData[0].roleName);

  const accessToken = useSelector(
    (state) => state.auth.authData[0].accessToken
  );

  


  const [permissions, setPermission] = React.useState({
    permission :[],
    selectedRole:"",
    loader:false,
  });
  const [userDetails, setUserDetails] = React.useState([]);

  const [modalOpen, setModalOpen] = React.useState(false);
  const [modalEditOpen , setEditModalOpen] = React.useState(false)

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      align: "center",
    },
    {
      title: "First Name",
      dataIndex: "first_name",
      align: "center",
    },
    {
      title: "Last Name",
      dataIndex: "last_name",
      align: "center",
    },
    {
      title: "Location",
      dataIndex: "location_name",
      align: "center",
    },
    {
      title: "Plant",
      dataIndex: "plant_name",
      align: "center",
    },
    {
      title: "Role",
      dataIndex: "role_name",
      align: "center",
    },
    {
      title: "Email",
      dataIndex: "email",
      align: "center",
         render:  (text) => {
          
            return (
              <div style={{ wordWrap: "break-word", wordBreak: "break-word" }}>
              {text ? <div className="xl:text-xs text-wrap">{text}</div> : null}
              </div>
            );
          },
      
    },
    {
      title: "Employee Id",
      dataIndex: "employee_id",
      align: "center",
  
      render:  (text) => {
        const employeeId = (text).toString().toUpperCase();
         return (
           <div style={{ wordWrap: "break-word", wordBreak: "break-word" }}>
           {text ? <div className="xl:text-xs text-wrap">{employeeId}</div> : null}
           </div>
         );
       },
    },
    {
      title: "Accessibility",
      align: "center",
      render: (record) => {
        const showIcon =
          (record?.role_name === "User" ||
            (record?.role_name === "Manager" && currentRole === "General Manager")) &&
          currentRole !== "User";
    
        return (
          <span
            style={{
              cursor: showIcon ? "pointer" : "default",
              display: "flex",
              justifyContent: "center",
              opacity: showIcon ? 1 : 0.2, // optional: fade if not active
              pointerEvents: showIcon ? "auto" : "none",
            }}
            onClick={() => {
              if (!showIcon) return;
              fetchPermissions(record.id);
              setPermission((data) => ({
                ...data,
                selectedRole: record.role_name,
              }));
              setModalOpen(true);
            }}
          >
            <img
              src="https://storage.googleapis.com/vin-dashboard/icons8-accessibility-tools-50.png"
              width="20px"
              height="auto"
              alt=""
            />
          </span>
        );
      },
    },
    {
      title: "Edit",
      align: "center",
      render: (record) => {
        const showIcon =
          (record?.role_name === "User" ||
            (record?.role_name === "Manager" && currentRole === "General Manager")) &&
          currentRole !== "User";
    
        return (
          <span
            style={{
              cursor: showIcon ? "pointer" : "default",
              display: "flex",
              justifyContent: "center",
              opacity: showIcon ? 1 : 0.2, // optional: fade if not active
              pointerEvents: showIcon ? "auto" : "none",
            }}
            onClick={() => {
              if (!showIcon) return;
              fetchUserData(record.id)
           
              setEditModalOpen(true);
            }}
          >
    <EditFilled/>
          </span>
        );
      },
    }
    
    
  ];
  

  const fetchPermissions = async (id) => {
    try {
      if (!accessToken) {
        return;
      }
      setPermission((data)=>{
        return {
          ...data,
          loader: true,
        };
      });
      const encryptedId = encryptAES(JSON.stringify(id));
      const res = await apiInterceptor.get(`/user-permissions/${encryptedId}/`);
      const { results } = res.data;
      if (results) {

        setPermission((data)=>{
          return {
            ...data,
            permission: results,
          };
        });
        //   setPlants(results);
      } else {
        console.warn("No results found in the response");
      }
    } catch (err) {
      console.log("Error fetching plant data:");
      if (err.response && err.response.data.code === "token_not_valid") {
        console.log("Token is invalid or expired.");
      } else {
        console.log("Error:", err.message || "Unknown log occurred");
      }
    }
    finally{
    
      setTimeout(()=>{
        setPermission((data)=>{
          return {
            ...data,
            loader: false,
          };
        });
      },500)
    }
  };

  const handleUpdatePermission = async (updatedPermissions) => {
    try {
      if (!accessToken) {
        return;
      }
    
      const encryptedData = encryptAES(JSON.stringify(updatedPermissions));
      const encryptedID = encryptAES(JSON.stringify(updatedPermissions.id));
      const res = await apiInterceptor.put(
        `/user-permissions/${encryptedID}/`,
        { data: encryptedData }
      );
   
      if (res.status === 200) {
            openNotification(
                 "success",
                 "Permission updated Successfully!",
                );
            setModalOpen(false);
        // fetchPermissions(updatedPermissions.user); 
      } else {
        console.error("Failed to update permissions:", res.data);
      }
    } catch (err) {
      console.error("Error updating permissions:", err);
    }
  }



  const fetchUserData = async (userID) => {
    try {
      const encryptedID = encryptAES(JSON.stringify(userID));
      console.log( await decryptAES(encryptedID))
      const url =  `/user/?user_id=${encryptedID}`
      const res = await apiInterceptor.get(url);
      if (res.data.results && res.status === 200) {
   
       setUserDetails(res.data.results[0])
      }
    } catch (error) {
      console.log(error);
    }
  };


  return (
    <>
   
      <PermissionModal
        permissionData={permissions.permission}
        selectedRole={permissions.selectedRole}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        handleUpdatePermission={handleUpdatePermission}
        loader={permissions.loader}
      />
      <EditModal
       modalOpen={modalEditOpen}
       setModalOpen={setEditModalOpen}
       userDetails={userDetails}
       handleGetUserData={handleGetUserData}
      />

      <ConfigProvider
        theme={{
          components: {
            Table: {
              colorBgContainer: "#fff",
              colorPrimary: "#000",
              colorFillAlter: "#fff",
              controlHeight: 48,
              headerBg: "#43996a",
              headerColor: "#fff",
              rowHoverBg: "#e6f7ff",
              padding: "1rem",
              boxShadowSecondary:
                "0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)",
              fontWeightStrong: 500,
            
             
            },
          },
        }}
      >
        <Table rowKey="id" columns={columns} dataSource={userData} scroll={{ x: "max-content" }}  />
      </ConfigProvider>
    </>
  );
};

export default UserTable;
